import { render, staticRenderFns } from "./DataStreamForm.vue?vue&type=template&id=47f36754&"
import script from "./DataStreamForm.vue?vue&type=script&lang=ts&"
export * from "./DataStreamForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports